import _ from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash } from "../../constant";
// import "bootstrap/dist/css/bootstrap.min.css";

const CustomSearchDropdown = (props) => {
    const wrapperRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    
    const requestPayloadInitials = {
      pageNumber: 1,
      pageSize: 10,
      sortArray: [],
      searchCriteria: [],
    };
    const [alertComponent, setAlertComponent] = useState({
      open: false,
      message: "",
      type: "",
    });

    const handleCloseAlert = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setAlertComponent({ ...alertComponent, open: false });
    };

    const [isLoading, setIsLoading] = useState(false);
    const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
    const [listing, setListing] = React.useState({
      totalPages: 0,
      currentPage: 1,
      totalItems: 0,
      [props?.listingArrName]: [],
    });

  // List of options for dropdown
  const options = [
    "Apple",
    "Banana",
    "Grapes",
    "Orange",
    "Mango",
    "Pineapple",
    "Strawberry",
    "Watermelon",
  ];

  // Handle search input and filter dropdown options
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value) {
      const filtered = options.filter((option) =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }

    setIsDropdownOpen(true); // Open dropdown when typing
  };

  // Handle selecting an option
  const handleSelect = (param) => {
    // console.log(param);
    props?.onSearchSelectChange({selectedLable: param?.selectedLable, selectedValue: param?.selectedValue}, param);
    // setSelectedOption(option);
    // setSearchTerm(option); // Set search term to selected option
    setIsDropdownOpen(false); // Close dropdown after selection
  };
  
  /**
   * Hook that alerts clicks outside of the passed ref
   */
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        const container = document.querySelector(
          ".search-dropdown"
        );
        if (container && !container.contains(event.target)) {
            setIsDropdownOpen(false);
        } else {
          // setIsNotificationOpen(true);
        }
      } else {
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  useEffect(() => {
    getListing(requestPayload, filterText);
  }, [requestPayload]);
  
  useEffect(() => {
    setSelectedOption(props?.defaultValue);
  }, [props?.defaultValue]);
  
  useEffect(() => {
    if ( props.isDependency == true ) {
      getListing(requestPayload, filterText);  
    }
  }, [props?.dependencyData?.keyValue]);
  
  const createLableName = (name1, name2) => {
    let str = `${name1}`;
    if (!isEmptyDash(name2)) {
      str += ` - ${name2}`;
    }
    return str;
  };

  const getListing = (requestPayloadParam, filterTextParam, formData) => {
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    
    if (props?.additionalData?.isMaster == true) {
        param += `&type=${props?.additionalData?.type}`;
    }
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    if (!isEmptyDash(props?.extraPromiseParam)) {
      param += `&${props?.extraPromiseParam}`;
    }
    
    if ( props.isDependency == true ) {
      if (!isEmptyDash(props?.dependencyData?.keyValue)) {
        param += `&${props?.dependencyData?.keyName}=${props?.dependencyData?.keyValue}`;  
        getListingFromPromise(props?.promiseRequest, param);      
      }     
    }
    else {
      getListingFromPromise(props?.promiseRequest, param);
    }
  };

  const getListingFromPromise = (promiseRequest, param) => {
    setIsLoading(true);
    if (!isEmptyDash(promiseRequest)) {      
      let promise = promiseRequest(param);
      promise.then((res) => {
        if (res.data.success === true) {
          res?.data?.data[props?.listingArrName]?.map((ele, i) => {
            ele["selectedLable"] = createLableName(ele[props?.additionalData?.lableKeyName1], ele[props?.additionalData?.lableKeyName2]);
            ele["selectedValue"] = `${ele[props?.additionalData?.valueKeyName]}`;
          })
          setListing(res?.data?.data);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        }
      })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
      // console.log("Debounce: ", searchTerm);

    }, 800),
    []
  );


  return (
    <div className="dropdown">
      {/* Input for searching the dropdown options */}
      <input
        type="text"
        className="form-control"
        placeholder="Please Select"
        
        value={selectedOption?.selectedLable}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        disabled={props?.isDisable}
      />

      {/* Dropdown list that appears when the input is clicked */}
      {isDropdownOpen && (
        <ul className="dropdown-menu search-dropdown show w-100" style={{ maxHeight: "200px", overflowY: "auto" }} ref={wrapperRef}>
          
          <input
            type="text"
            className="form-control search-select-input"
            placeholder="Search"
            
            onChange={onFilterTextChange}
            value={filterText}
            onKeyPress={onKeyPressHandler}
          />
          {listing[props?.listingArrName].length > 0 ? (
            listing[props?.listingArrName].map((option, index) => (
              <li key={option[props?.additionalData?.valueKeyName]}>
                <button
                  className="dropdown-item"
                  onClick={() => handleSelect(option)}
                >
                  {`${option["selectedLable"]}`}
                </button>
              </li>
            ))
          ) : (
            <li className="dropdown-item">No results found</li>
          )}
        </ul>
      )}
      
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      
    </div>
  );
};

export default CustomSearchDropdown;
